import { render } from "./NearbyPlaces.vue?vue&type=template&id=128665d0&scoped=true"
import script from "./NearbyPlaces.vue?vue&type=script&lang=js"
export * from "./NearbyPlaces.vue?vue&type=script&lang=js"

import "./NearbyPlaces.vue?vue&type=style&index=0&id=128665d0&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128665d0"]])

export default __exports__